import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-context" }

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { computed, onMounted, reactive, ref } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import DecisionBtn from '@/components/input/Btn/DecisionBtn.vue';
import CancelBtn from '@/components/input/Btn/CancelBtn.vue';
import { flexRow, padding2em } from '@/appLogic/constants/layoutConst';
import { CustomStyle } from '@/appLogic/interfaces/style';

// interface
type ModalSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'auto';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    modalState: { type: Boolean },
    okButtonText: { default: String(i18n.t('続行')) },
    cancelButtonText: { default: String(i18n.t('変更')) },
    size: { default: 'md' },
    okValidate: { type: Boolean, default: false }
  },
  emits: ["validate-ok", "ok", "cancel", "outside-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

// style variables
const FlexRow = flexRow;

//変数
const t = i18n.t;
const setState = reactive({ state: props.modalState }) as Record<string, any>;

//computed

// イベント

//関数
const onClickOk = () => {
  if (props.okValidate) {
    emits('validate-ok');
  } else {
    emits('ok');
  }
};
const onClickCancel = () => {
  emits('cancel');
};

// TODO: md-系だとどこかで.preventDefaultされてるか何かでoutside-clickのイベントが上がってこないのでこいつ現状意味ない。。。
// そもそもmd系を使わないようにしたい
const outsideClick = (outsideClick) => {
  emits('outside-click', outsideClick);
};

// customStyle
// decisionBtnのカスタムスタイル
const decisionBtnCustomStyle: CustomStyle = {
  Div: {
    marginRight: '50px',
  },
};
// cancelBtnCustomStyleのカスタムスタイル
const cancelBtnCustomStyle: CustomStyle = {
  Div: {
    marginLeft: '50px',
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-state": _ctx.modalState,
    size: _ctx.size,
    onOutsideClick: outsideClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_unref(FlexRow), null, {
        default: _withCtx(() => [
          _createVNode(DecisionBtn, {
            "label-name": _ctx.okButtonText,
            "custom-style": decisionBtnCustomStyle,
            onClick: onClickOk
          }, null, 8, ["label-name"]),
          _createVNode(CancelBtn, {
            "label-name": _ctx.cancelButtonText,
            "custom-style": cancelBtnCustomStyle,
            onClick: onClickCancel
          }, null, 8, ["label-name"])
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 3
  }, 8, ["modal-state", "size"]))
}
}

})